import { currentDomain } from "../app/variables";

export default async ({ req, app, store }) => {
  const settings = await import("~/apollo/queries/settings");
  const host = req?.headers?.host || (process.client ? window.location.hostname : app.$currentDomain);
  let currentSettings = {};
  let client = app.apolloProvider.defaultClient;
  let sources = ['review', 'help', 'auto', 'topotziv'];
  try {
    let settingsResponse = await client.query({
      query: settings.default || settings,
      variables: { site_id: currentDomain(host).id }
    });
    (settingsResponse.data?.settings?.settings || []).forEach(value => {
      if (value?.key) currentSettings[value.key] = value.value;
    });
    const utmSource = app.$cookies.get('utm_source');
    if (utmSource && sources.includes(utmSource) && currentSettings[`phone_${utmSource}_otzovik`]) {
      currentSettings['phone'] = currentSettings[`phone_${utmSource}_otzovik`];
    }
    store.commit('settings/settings/SET_SETTINGS', currentSettings);
    if (currentSettings.domain) {
      try { store.commit('SET_DOMAIN', new URL(/^https?:/.test(currentSettings.domain) ? currentSettings.domain : `https://${currentSettings.domain}`).hostname); } catch (_) {}
    }
  } catch (error) {
    console.error('Ошибка загрузки настроек:', error);
  }
}
